export const en = {
    from: 'Departure',
    to: 'Back',
    one_way: 'One way',
    round_trip: 'Round trip',
};
